import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './currency-info-modal.scss';

interface CurrencyInfoModalProps {
  show: boolean;
  onHide: () => void;
}

const CurrencyInfoModal: React.FC<CurrencyInfoModalProps> = ({ show, onHide }) => {
  const { t } = useTranslation();
  
  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered
      className="currency-info-modal"
    >
      <Modal.Header>
        <Modal.Title>{t('CURRENCY_INFO_MODAL_TITLE')}</Modal.Title>
        <button 
          type="button" 
          className="close-btn" 
          onClick={onHide}
          aria-label="Close"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path 
              d="M18 6L6 18M6 6L18 18" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="modal-body-content">
          {/* <div className="info-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
              <path d="M12 16V12M12 8H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div> */}
          <div className="currency-chips" aria-hidden="true">
            {['EUR', 'USD', 'GBP', 'CHF', 'CAD', 'AUD', 'NOK', 'DKK', 'JPY', 'CNY'].map((c) => (
              <span className="currency-chip" key={c}>{c}</span>
            ))}
            <span className="currency-chip currency-chip--sek">SEK</span>
          </div>
          <p className="main-text">
            {t('CURRENCY_INFO_MODAL_MAIN_TEXT')}
          </p>
          <div className="info-box">
            <p className="additional-info">
              {t('CURRENCY_INFO_MODAL_ADDITIONAL_INFO')}
            </p>
          </div>
          <div className="contact-section">
            <p className="contact-text">
              {t('CURRENCY_INFO_MODAL_CONTACT_TEXT')}
            </p>
            <a href={`mailto:support@invozio.com`} className="contact-link">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M3 5L8.5 10L3 15M10 5L15.5 10L10 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2 3H18C18.5523 3 19 3.44772 19 4V16C19 16.5523 18.5523 17 18 17H2C1.44772 17 1 16.5523 1 16V4C1 3.44772 1.44772 3 2 3Z" stroke="currentColor" strokeWidth="1.5"/>
              </svg>
              {t('CURRENCY_INFO_MODAL_CONTACT_EMAIL')}
            </a>
            <button type="button" className="currency-ok-btn" onClick={onHide}>
              {t('OK') || 'OK'}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CurrencyInfoModal;
